import {Website} from "../layouts/Website";

import {Box, Container, Grid, Typography} from "@mui/material";
import {homeMap} from "../data/homeMap";
import {HomeTextBlock} from "../components/shared/HomeTextBlock";
import {PageTitle} from "../components/shared/PageTitle";
import {programMap} from "../data/programMap";
import {CardProgramma} from "../components/Programma/CardProgramma";
import React from "react";

const HomePage = () => {
    return(
        <Website>
            <Box sx={{width:'100%', display:'flex', flexDirection:'column', alignItems:'center'}}>
                <img style={{width:'100%', objectFit:'cover', height:'600px'}} src={'/images/img-home.png'} alt={'home-header'}/>
                <Box sx={{width: '100%', backgroundColor: '#d2202e', height: '60%', marginTop:0}}>
                    <h1 style={{
                        paddingTop:'16px',
                        marginTop:0,
                        marginBottom:0,
                        position: 'relative',
                        fontWeight: '700',
                        color: '#fff',
                        zIndex: '2',
                        textAlign: 'center',
                        fontFamily: 'Monument Extended'
                    }}>
                        SALES CONVENTION
                    </h1>
                    <h3 style={{
                        marginTop:0,
                        marginBottom:0,
                        position: 'relative',
                        fontWeight: 'normal',
                        color: '#fff',
                        textAlign: 'center',
                        fontFamily: 'Monument Extended',
                        paddingBottom:'16px',
                    }}>
                        MARRAKECH | 12-14 MARZO 2025
                    </h3>
                </Box>
            </Box>
            <Container sx={{ pt:6 }}>
                <PageTitle title={'Programma di viaggio'} image={'icon-programma'}/>
                <Grid container spacing={2} sx={{pt:2}}>
                    {
                        programMap.map((day, index) =>
                            <Grid item xs={12} md={6} lg={4} key={index}>
                                <CardProgramma day={day} i={index}/>
                            </Grid>
                        )}
                </Grid>
            </Container>
            {/*<Container sx={{py: 2}}>
                {
                    homeMap.map((part, index) =>
                        <Box key={part.title} sx={{pb: 2}} key={part.title}>
                            {
                                part.sections.map((section, index) =>
                                    <HomeTextBlock section={section} key={section.title} direction={'row'}/>
                                )
                            }
                        </Box>
                    )
                }
            </Container>*/}
        </Website>
    )
}

export default HomePage;